import { render, staticRenderFns } from "./HeroWithBtns.vue?vue&type=template&id=0a885a04&scoped=true&"
import script from "./HeroWithBtns.vue?vue&type=script&lang=js&"
export * from "./HeroWithBtns.vue?vue&type=script&lang=js&"
import style0 from "./HeroWithBtns.vue?vue&type=style&index=0&id=0a885a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a885a04",
  null
  
)

export default component.exports